
import EventItem from '@/components/events/event-item';

export default class EventItemFull extends EventItem {}
